import { router, IBaseComponent } from '@codesuma/baseline'

// Wide enough for the calendar and the day to stand side by side. The same
// width as the media queries in app.module.css and the day page's stylesheets —
// all of them have to be changed together. A rem here is the browser's default
// text size, 16px, exactly as it is in a media query, so the number matches.
const panels = window.matchMedia('(min-width: 68rem)')
export const paneled = () => panels.matches

// Every page the router has built, by route. The router keeps a cache of its
// own but does not hand it out, and open() below needs the instance.
const pages: Record<string, IBaseComponent<any>> = {}

export const remember = (path: string, page: IBaseComponent<any>) => {
    pages[path] = page
}

const query = (search: string) => Object.fromEntries(new URLSearchParams(search))

// The enter the router would have sent, sent by hand.
const reenter = (page: IBaseComponent<any>, path: string, search: string, isBack: boolean) =>
    page.emit('enter', { params: {}, query: query(search), from: path, to: path, isBack })

// Go to a route, including one that only changes the query.
//
// The router returns early when the path asked for is the one already showing,
// and on a phone that is never in the way: you cannot reach the calendar
// without leaving the day, so /day is always asked for from somewhere else. In
// the two-panel layout the calendar stays on screen beside the day, so tapping
// a second date asks for /day again with a different ?d= — and the router
// ignores it. Push the address and re-enter the page instead.
export const open = (to: string) => {
    const [path, search = ''] = to.split('?')
    const page = pages[path]
    if (path !== router.getPath() || !page) return router.goto(to)
    history.pushState(null, '', to)
    reenter(page, path, search, false)
}

// And the way back through those entries, which the router skips for the same
// reason. A back that does change the path is left alone — the router's own
// listener has that one.
window.addEventListener('popstate', () => {
    const path = window.location.pathname
    const page = pages[path]
    if (path !== router.getPath() || !page) return
    reenter(page, path, window.location.search.slice(1), true)
})
